import React from 'react';

/**
 * Catches rendering errors so a failure shows a message instead of a blank page.
 * The usual culprit on this site is a browser translation tool (e.g. Google Translate)
 * rewriting text that React later tries to update. Remounted on each route change
 * (via `key`) so navigating away recovers.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'exception', { description: String(error), fatal: false });
    }
    console.error(error, info);
  }

  render() {
    const { messages, children } = this.props;
    if (!this.state.hasError) return children;
    return (
      <div className="error-boundary" role="alert">
        <h1>{messages.title}</h1>
        <p>{messages.text}</p>
        <button type="button" onClick={() => window.location.reload()}>{messages.reload}</button>
      </div>
    );
  }
}

export default ErrorBoundary;
